import PropTypes from "prop-types";
import React from "react";
import { formatNumber } from "util/strings";

const ListingPrice = ({
  listing,
  estimatedPriceDisplayStyle,
  lowestPricePerSeatPerMonth,
  negotiable,
  children,
  ...props
}) => {
  const showAccurate = listing?.accurateMonthlyPrice > 0;
  const hasEstimate = listing?.estimatedMonthlyPrice > 0;
  const showEstimate = false;

  let price;
  let pricePerSquarefoot;

  if ((props.showAccurate || hasEstimate) && showAccurate) {
    price = `$${formatNumber(listing.accurateMonthlyPrice)}`;
    pricePerSquarefoot = `$${formatNumber(listing.accuratePsf)}`;
  } else if (lowestPricePerSeatPerMonth) {
    price = `$${formatNumber(lowestPricePerSeatPerMonth)}`;
  } else if (showEstimate) {
    if (estimatedPriceDisplayStyle === "tilde") {
      price = `~$${formatNumber(listing.estimatedMonthlyPrice)}`;
      pricePerSquarefoot = `$${formatNumber(listing.estimatedPsf)}`;
    } else {
      price = `$${formatNumber(listing.estimatedMonthlyPrice)}`;
      pricePerSquarefoot = `$${formatNumber(listing.estimatedPsf)}`;
    }
  }

  if (!price) {
    return null;
  }
  return (
    <span>
      <span>{price}</span>
      {estimatedPriceDisplayStyle === "est" && (
        <span>{!(props.showAccurate && showAccurate) ? " est. " : "/mo "}</span>
      )}
      {lowestPricePerSeatPerMonth && <span>+/mo</span>}
      {negotiable && <span>negotiable ({pricePerSquarefoot} psf)</span>}
      {children}
    </span>
  );
};

ListingPrice.propTypes = {
  children: PropTypes.node,
  estimatedPriceDisplayStyle: PropTypes.string,
  listing: PropTypes.shape({
    accurateMonthlyPrice: PropTypes.number,
    accuratePsf: PropTypes.number,
    estimatedMonthlyPrice: PropTypes.number,
    estimatedPsf: PropTypes.number,
  }).isRequired,
  lowestPricePerSeatPerMonth: PropTypes.string,
  negotiable: PropTypes.bool,
  showAccurate: PropTypes.bool,
};

ListingPrice.defaultProps = {
  children: null,
  estimatedPriceDisplayStyle: null,
  lowestPricePerSeatPerMonth: null,
  negotiable: null,
  showAccurate: null,
};

export default ListingPrice;
